module.exports = __webpack_public_path__ + "img/user_lz_zx_selected.c79774a8.png";